import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VerificationModalComponent } from '../../verification-modal/verification-modal.component';

@Component({
  selector: 'app-locked-modal',
  templateUrl: './locked-modal.component.html',
  styleUrls: ['./locked-modal.component.css']
})
export class LockedModalComponent implements OnInit {

  dialogRef;

  constructor(public dialog: MatDialog) { }

  ngOnInit(): void {
  }

  openModal(){
    this.dialogRef = this.dialog.open(VerificationModalComponent, {
      data: {},
    });
    return this.dialogRef;
  }

}
